module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "navbar"
    }
  }, [_vm._m(0), _vm._v(" "), _c('header', {
    staticClass: "color-1 hovered menu-3"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "nav"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('nav', {
    staticClass: "menu"
  }, [_c('ul', [_c('li', {
    staticClass: "type-1 active"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', {
    staticClass: "type-1"
  }, [_vm._m(3), _vm._v(" "), _c('ul', {
    staticClass: "dropmenu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "active-class": "active",
      "to": "/contact"
    }
  }, [_vm._v("111")])], 1), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "style-page"
  }, [_c('div', {
    staticClass: "wrappers"
  }, [_c('div', {
    staticClass: "conf-button"
  }, [_c('span', {
    staticClass: "fa fa-bed",
    staticStyle: {
      "color": "#ff6600"
    }
  }), _vm._v(" "), _c('h6', [_vm._v("Book now")])]), _vm._v(" "), _c('p', [_vm._v("booking button content")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "logo",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo_dark1.png",
      "alt": "Hostal Pelikan"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-menu-icon"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Nosotros\n                                        "), _c('span', {
    staticClass: "fa fa-angle-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Mission")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "type-1"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Habitaciones\n                                        "), _c('span', {
    staticClass: "fa fa-angle-down",
    staticStyle: {
      "color": "red"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropmenu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Para familia")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Para tener familia")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "type-1"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Services\n                                        "), _c('span', {
    staticClass: "fa fa-angle-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropmenu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Something")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "type-1"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Contacto\n                                        "), _c('span', {
    staticClass: "fa fa-angle-down"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {}
  }, [_c('span', {
    staticClass: "btn btn-default",
    staticStyle: {
      "border-radius": "25px",
      "font-weight": "700",
      "border-color": "#ff6600",
      "background": "none !important"
    }
  }, [_c('i', {
    staticClass: "fa fa-phone",
    staticStyle: {
      "color": "#ff6600"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v(" +57 (5) 4 219057")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8fa23452","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar.vue
// module id = 18
// module chunks = 0